module.exports = __webpack_public_path__ + "static/img/20汉展.d9b0746.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/20汉展.jpg
// module id = M7rw
// module chunks = 1